
import ButtonIcon from "../../../components/Buttons/ButtonIcon/ButtonIcon";
import {MessageTwoTone} from "@ant-design/icons";
import React from "react";
import { ReactComponent as Bell } from "../../../assets/icon/bell.svg"
import { ReactComponent as Alarm } from "../../../assets/icon/alararm.svg";
import { ReactComponent as SearchMobile } from "../../../assets/icon/searchMobile.svg";
import { ReactComponent as MessagesMobile } from "../../../assets/icon/messagesMobile.svg";

import {IconsContainer} from "../../styled";
const HeaderIcons = ({ isMobile }:{isMobile:boolean}) => {
    return (
        <IconsContainer>
            {isMobile && (            <ButtonIcon
                type="text"
                icon={<SearchMobile/>}
                onClick={() => {
                }}

                style={{fontSize: '14px'}}
            />)}
            <ButtonIcon
                type="text"
                icon={<Bell/>}
                onClick={() => {
                }}

                style={{fontSize: '14px'}}
            />
            <ButtonIcon
                type="text"
                icon={<MessagesMobile/>}
                onClick={() => {
                }}

                style={{fontSize: '14px'}}
            />
            <ButtonIcon
                type="text"
                icon={<Alarm/>}
                onClick={() => {
                }}

                style={{fontSize: '14px'}}
            />
        </IconsContainer>
    )
}
export default HeaderIcons